<template>
  <div>
    <div class="order-create__row custom-row">
      <div class="custom-col custom-col--33 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['common_comment'])"></div>
        <TextareaDefault
            :label="$t('common_comment.localization_value.value')"
            v-model="engravingItem.data.comment"
        />
      </div>
    </div>
    <div class="order-create__row custom-row">
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_engravingLength'])"></div>
        <DefaultInput
            :label="$t('fbm_engravingLength.localization_value.value')"
            :type="'text'"
            v-bind:class="{'ui-no-valid': engravingItem.data.Dimensions.validation.dimensionLength}"
            :errorTxt="$t(`${engravingItem.data.Dimensions.validationTranslate.dimensionLength}.localization_value.value`)"
            :error="engravingItem.data.Dimensions.validation.dimensionLength"
            v-model="engravingItem.data.Dimensions.data.dimensionLength"
            @input.native="changeEngravingPrice($event, 'length')"
            @change="calculateEngravingPrice"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_engravingWidth'])"></div>
        <DefaultInput
            :label="$t('fbm_engravingWidth.localization_value.value')"
            :type="'text'"
            v-bind:class="{'ui-no-valid': engravingItem.data.Dimensions.validation.width}"
            :errorTxt="$t(`${engravingItem.data.Dimensions.validationTranslate.width}.localization_value.value`)"
            :error="engravingItem.data.Dimensions.validation.width"
            v-model="engravingItem.data.Dimensions.data.width"
            @input.native="changeEngravingPrice($event, 'width')"
            @change="calculateEngravingPrice"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_engravingCount'])"></div>
        <DefaultInput
            :label="$t('fbm_engravingCount.localization_value.value')"
            :type="'text'"
            v-bind:class="{'ui-no-valid': engravingItem.validation.count}"
            :errorTxt="$t(`${engravingItem.validationTranslate.count}.localization_value.value`)"
            :error="engravingItem.validation.count"
            v-model="engravingItem.data.count"
            @input.native="changeEngravingPrice($event, 'count')"
            @change="(val) => {calculateEngravingPrice(); $emit('changeQuantity', engravingItem.data.customization, val)}"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['calculatorEngraving_product',])"></div>
        <DefaultSelect
            :options="engravingCustomOptions"
            :label="$t('calculatorEngraving_product.localization_value.value')"
            :otherValue="'calculatorCustomization'"
            :selected="engravingItem.data.customization"
            @change="changeCustomization"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_engravingPrice'])"></div>
        <DefaultInput
            :label="$t('fbm_engravingPrice.localization_value.value')"
            :type="'text'"
            :disabled="true"
            v-model="engravingItem.data.engravingPrice"
        />
      </div>
    </div>

    <div
        v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate(['fbm_engravingAcceptFiles1'])"></div>
      {{ $t('fbm_engravingAcceptFiles1.localization_value.value') }}
    </div>
    <div class="order-create__row custom-row">
      <div class="custom-col position-relative"
           v-if="engravingItem.data.EngravingFile.data.maxCountFiles - Object.keys(engravingItem.data.EngravingFile.data.downloadFiles).length > 0">
        <DropZone class="drop-zone-bg"
                  :parentFiles="engravingItem.data.EngravingFile.data.files"
                  :multiple="true"
                  :maxCount="engravingItem.data.EngravingFile.data.maxCountFiles - engravingItem.data.EngravingFile.data.downloadFiles.length"
                  :maxSize="engravingItem.data.EngravingFile.data.maxSizeFiles"
                  @changeImg="(files, maxSize) => {changeFile(files, maxSize)}"
                  :accept="'/*'"
        />
        <div class="error-field ml-3" v-if="engravingItem.data.EngravingFile.validation.files">
          {{ $t('common_fileIsRequired.localization_value.value') }}
        </div>
      </div>

      <div class="custom-col mt-4 mb-0"
           v-if="Object.keys(engravingItem.data.EngravingFile.data.downloadFiles).length > 0"
      >
        <div class="custom-row product-img-row">
          <div class="custom-col custom-col--16 custom-col--md-25 custom-col--sm-100"
               v-for="(item, index) in engravingItem.data.EngravingFile.data.downloadFiles"
               :key="index">
            <DownloadFileBlock
                :file="item"
                @removeFile="(id) => {removeFile(id, index)}"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultSelect from "@/components/UI/selectiones/DefaultSelect/DefaultSelect";
import DefaultInput from "@/components/UI/inputs/DefaultInput/DefaultInput";
import DownloadFileBlock from "@/components/coreComponents/DownloadFileBlock/DownloadFileBlock";
import DropZone from "@/components/coreComponents/DropZone/DropZone";
import TextareaDefault from "@/components/UI/textarea/TextareaDefault/TextareaDefault";

export default {
  name: "EngravingItem",
  components: {TextareaDefault, DefaultSelect, DefaultInput, DownloadFileBlock, DropZone},

  props: {
    FBM: Object,
    engravingItem: Object,
    engravingCustomOptions: Array,
    engravingsCount: Number,
    index: Number,
  },

  watch: {
    engravingsCount(newVal, oldVal) {
      if((newVal === 1 || newVal === 2) && (oldVal === 1 || oldVal === 2) && this.index === 0) {
        this.calculateEngravingPrice()
      }
    }
  },

  methods: {

    changeCustomization(val) {
      let oldCustomization = this.engravingItem.data.customization
      this.engravingItem.data.customization = val;
      this.calculateEngravingPrice();
      this.$emit('changeCustomization', oldCustomization, val, this.engravingItem.data.count)
    },

    removeTenths() {
      if(('' + this.engravingItem.data.Dimensions.data.dimensionLength).indexOf('.') > -1) this.engravingItem.data.Dimensions.data.dimensionLength = this.engravingItem.data.Dimensions.data.dimensionLength.split('.')[0]
      if(('' + this.engravingItem.data.Dimensions.data.width).indexOf('.') > -1) this.engravingItem.data.Dimensions.data.width = this.engravingItem.data.Dimensions.data.width.split('.')[0]
      if(('' + this.engravingItem.data.count).indexOf('.') > -1) this.engravingItem.data.count = this.engravingItem.data.count.split('.')[0]
    },

    changeEngravingPrice(event, type = false) {

      if(type) {
        switch (type) {
          case 'length':
            this.engravingItem.data.Dimensions.data.dimensionLength = event.target.value.replace(',', '.').replace(/[^0-9.]/g, '')
            break
          case 'width':
            this.engravingItem.data.Dimensions.data.width = event.target.value.replace(',', '.').replace(/[^0-9.]/g, '')
            break
          case 'count':
            this.engravingItem.data.count = event.target.value.replace(',', '.').replace(/[^0-9.]/g, '')
            break
          default:
            break
        }

        /**
         * Remove Tenths
         */
        this.removeTenths()
      }
    },

    calculateEngravingPrice() {
      if(
          (!this.engravingItem.data.Dimensions.data.dimensionLength || this.engravingItem.data.Dimensions.data.dimensionLength.length === 0) ||
          (!this.engravingItem.data.Dimensions.data.width || this.engravingItem.data.Dimensions.data.width.length === 0) ||
          (!this.engravingItem.data.count || this.engravingItem.data.count.length === 0)
      ) {
        return
      }

      let data = {
        offer: this.engravingItem.data.customization ? this.engravingItem.data.customization?.id : null,
        length: this.engravingItem.data.Dimensions.data.dimensionLength,
        width: this.engravingItem.data.Dimensions.data.width,
        count: this.engravingItem.data.count,
        need_different_engrave: this.engravingsCount > 1,
        need_adjusting_layout: false,
      }

      this.$store.dispatch('getEngravingCalcPriceInOrder', data).then(response => {
        if(this.getRespData(response)?.engraving_cost) {
          this.engravingItem.data.engravingPrice = parseFloat(this.getRespData(response)?.engraving_cost).toFixed(2)
        }
      })
    },

    changeFile(files, maxSizeError) {
      this.engravingItem.data.EngravingFile.setFiles(files)

      this.engravingItem.data.EngravingFile.setFilesMaxSizeError(maxSizeError)

      this.calculateEngravingPrice()
    },

    removeFile(id, index){

      let text = {
        title: 'common_AreYouSure',
        txt: '',
        yes: 'common_confirmDelete',
        no: 'common_confirmNo'
      }

      let confirm = () => {

        let fileKey = Object.keys(this.engravingItem.data.EngravingFile.data.downloadFiles[index])[0]
        if(fileKey) {
          this.FBM.data.removedCustomizationFiles.push(this.engravingItem.data.EngravingFile.data.downloadFiles[index][fileKey]?.uuid)
          this.engravingItem.data.EngravingFile.removeDownloadFile(index)
          this.calculateEngravingPrice()
        }

        // this.$store.dispatch('removeUserDocument', id).then(() => {
        //
        //   this.engravingItem.data.EngravingFile.removeDownloadFile(index)
        //
        //   this.calculateEngravingPrice()
        // })

        this.$store.commit('setConfirmDeletePopup', false)
        return true
      }

      this.deleteFunc(text, confirm)


    },
  },
}
</script>

<style scoped>

</style>